<div class="modal-header">
    <h5 class="modal-title pull-left">
        Attachments 
    </h5>
    <a class="close pull-right" aria-label="Close" (click)="onModalClose()">
        <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
    </a>
</div>
<div class="card attachment-container">
    <div class="card-head">
        <ul>
            <ng-container *ngFor="let tab of attachmentTabs">
                <li [ngClass]="{
                  'active' : tab.identifier === activeTab.identifier  
                }"
                (click)="changeTab(tab)">
                    <a>{{tab.name}}</a>
                </li>
            </ng-container>
        </ul>
    </div>
    <div class="card-body">
        <section class="prUpload">
            <div class="prUpload__head">
                <div class="prUpload__head__title">
                    <h5 class="mt-2 text-head">{{activeTab.name}}</h5>
                </div>
            </div>
            <ng-container *ngIf="activeTab.identifier === 'upload'">
                <div class="prUpload__content">
                    <div class="file-upload pt-0">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5 position-relative">
                                <div class="upload-container">
                                    <div class="upload-icon mx-3">
                                        <span class="fa fa-cloud-upload fa-5x"></span>
                                    </div>
                                    <div class="upload-title mx-3">
                                        <p>
                                            <span *ngIf="!prFiles[0]?.file">Drag and drop the PR file to upload</span>
                                            <span *ngIf="prFiles[0]?.file">{{prFiles[0]?.file?.name+"..."}}</span>
                                            <!-- {{ prFiles[0]?.file?.name+"..." || "Drag and drop the PR file to upload"}} -->
                                        </p>
                                    </div>
                                    <input type="file" #inputFile id="choose" multiple (change)="onFileChange($event)" />
                                </div>
                                <div class="text-center my-3">
                                    <a class="btn btn-outline-primary btn-lg" (click)="inputFile.click()">
                                        Choose File
                                    </a>
                                </div>
                                <div class="upload-instructions my-5 text-start">
                                    <h6>Upload Instructions: </h6>
                                    <ul>
                                        <li class='font-small'>
                                            1. Only xls, xlsx file format is supported
                                        </li>
                                        <li class='font-small'>
                                            2. During file upload, total size of the file must not exceed 20MB
                                        </li>
                                        <li class='font-small'>
                                            3. Only one file can be uploaded at a time
                                        </li>
                                    </ul>
                                </div>
                                <div class="divider"></div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5">
                                <div class="px-4 py-1">
                                    <div class="text-start">
                                        <h6 class="fs-6">File Status</h6>
                                        <p class="text-muted my-3" *ngIf="!prFiles?.length">
                                            Please select the files to be uploaded.
                                        </p>
                                        <p className="text-muted my-3" *ngIf="prFiles?.length">
                                            File to be uploaded ({{prFiles?.length}} files).
                                        </p>
                                    </div>
                                    <ng-container *ngIf="prFiles?.length">
                                        <div class="mt-4 upload-view" *ngFor="let prFile of prFiles">
                                            <div>
                                                <p class='mb-1'>
                                                    {{prFile?.file?.name}}
                                                </p>
                                                <p class="mb-0 font-small">
                                                    {{prFile?.formatSize}}
                                                </p>
                                            </div>
                                            <div class='align-self-center'>
                                                <a class='pointer' (click)="clearFile(prFile.file)">
                                                    <span class="fa fa-trash fa-2x"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-action">
                        <button class="btn btn-outline-primary mx-2" (click)="onModalClose()">
                            Cancel
                        </button>
                        <button class="btn btn-primary text-white mx-2"
                            (click)="validateFiles()">
                            Upload File
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="activeTab.identifier === 'uploaded'">
                <div class="mt-4 upload-view col-12 me-2" *ngFor="let prFile of uploadedFiles">
                    <div>
                        <p class='mb-1'>
                            {{prFile?.name}}
                        </p>
                        <p class="mb-0 font-small">
                            {{(prFile.size/1024).toFixed(2)}} KB
                        </p>
                    </div>
                    <div class='align-self-center'>
                        <a class='pointer mx-2 cursor-pointer' (click)="downloadRFQtemplate(prFile)">
                            <span class="fa fa-cloud-download fa-2x"></span>
                        </a>
                        <a class='text-danger pointer mx-2 cursor-pointer' (click)="deleteRFQtemplate(prFile.id)">
                            <span class="fa fa-trash fa-2x"></span>
                        </a>
                    </div>
                </div>
            </ng-container>
        </section>
    </div>
</div>